// extracted by mini-css-extract-plugin
export var icon = "_bx-3";
export var subtitle = "_bx-2";
export var title = "_bx-1";
export var value = "_bx-0";